export const ICON_SIZE = 40;

export default function ServiceLogo({
	iconSrc,
	iconLabel,
	logoSrc,
	logoHeight
}: {
	iconSrc?: string;
	iconLabel?: string;
	logoSrc: string;
	logoHeight: number;
}) {
	return (
		<>
			{iconSrc && (
				<>
					<svg
						className='ribbon-service__icon'
						version='1.1'
						xmlns='http://www.w3.org/2000/svg'
						viewBox={`0 0 ${ICON_SIZE} ${ICON_SIZE}`}
					>
						<defs>
							<mask id='ribbon-squircle-mask'>
								<rect
									x='0'
									y='0'
									width={`${ICON_SIZE}`}
									height={`${ICON_SIZE}`}
									fill='#000000'
								/>
								<path
									fill='#ffffff'
									fillRule='nonzero'
									d='M30.49 38.885a10.948 10.948 0 0 0 8.394-8.393A49.607 49.607 0 0 0 40 20c0-3.6-.385-7.11-1.116-10.491a10.948 10.948 0 0 0-8.392-8.393A49.611 49.611 0 0 0 20 0C16.4 0 12.89.385 9.51 1.116A10.949 10.949 0 0 0 1.116 9.51 49.6 49.6 0 0 0 0 19.999c0 3.6.385 7.11 1.116 10.492a10.949 10.949 0 0 0 8.393 8.393A49.584 49.584 0 0 0 20 40c3.6 0 7.11-.385 10.49-1.115'
								/>
							</mask>
						</defs>
						<image
							xlinkHref={iconSrc}
							mask='url(#ribbon-squircle-mask)'
							width={`${ICON_SIZE}`}
							height={`${ICON_SIZE}`}
						/>
					</svg>
					{iconLabel && <span className='ribbon-service__icon-label'>{iconLabel}</span>}
				</>
			)}
			<img
				alt={iconLabel || ''}
				style={{ height: `${logoHeight}px` }}
				className='ribbon-service__logo'
				src={logoSrc}
			/>
		</>
	);
}
